// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class ManagedObjectTMO {
	public managedObjectId: string = undefined;

	public managedObjectType: ManagedObjectTypeEnum = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class ManagedObject extends ManagedObjectTMO {}


// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************


// ENUMS #############################################################
// API enums *********************************************************
export enum ManagedObjectTypeEnum {
	TENANT = 'tenant',
	ORGANIZATION = 'organization',
	BUSINESS_PREMISES = 'businesspremises',
}
